import { render } from "./MjknView.html?vue&type=template&id=83789b7c&ts=true&external"
import script from "./MjknView.ts?vue&type=script&lang=ts&external"
export * from "./MjknView.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__